"use client";

import React from "react";
import { ResponsiveModal, ModalContainer, MODAL_IDS } from "@west-tennessee-consulting/ui";
import { CompanyConsolidationForm } from "./CompanyConsolidationModal";
import type { ConsolidateCompanyModalData } from "@/lib/modals/data/modal-data-types";

/**
 * Company Consolidation Modal Wrapper - ModalContainer pattern
 *
 * This component:
 * 1. Uses ModalContainer to manage modal state and data
 * 2. Reads companyId from modal data
 * 3. Renders the CompanyConsolidationForm with the companyId
 * 4. Provides onClose callback for form submission
 *
 * Usage from SimpleTable row action:
 * ```typescript
 * openModal(MODAL_IDS.companies.consolidate, {
 *   companyId: item.id,
 * });
 * ```
 */
export function CompanyConsolidationModalWrapper() {
  return (
    <ModalContainer<ConsolidateCompanyModalData> modalId={MODAL_IDS.companies.consolidate}>
      {({ isOpen, data, onClose }) => (
        <ResponsiveModal
          globalModalId={MODAL_IDS.companies.consolidate}
          title="Consolidate Company"
          description="Merge this company with another company. All data will be combined and the source company will be deleted."
          maxWidth="lg"
        >
          <CompanyConsolidationForm
            companyId={data?.companyId}
            onClose={onClose}
          />
        </ResponsiveModal>
      )}
    </ModalContainer>
  );
}
